import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import OrderBar from '.';

class OrderBarPortal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mounted: false
        };
    }

    componentDidMount() {
        this.setState({
            mounted: true
        });
    }

    render() {
        const { OrderBarComponent } = this.props;
        const { mounted } = this.state;

        if (!mounted) {
            return null;
        }

        return ReactDOM.createPortal(
            <OrderBarComponent {...this.props} />,
            document.getElementById('order-bar-root')
        );
    }
}

OrderBarPortal.propTypes = {
    OrderBarComponent: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func
    ])
};

OrderBarPortal.defaultProps = {
    OrderBarComponent: OrderBar
};

export default OrderBarPortal;
